// extracted by mini-css-extract-plugin
export var content = "AltLoginsForm-module__content___W3Ual";
export var apple = "AltLoginsForm-module__apple___mUI7L";
export var google = "AltLoginsForm-module__google___K1MeV";
export var text = "AltLoginsForm-module__text___bkNLy";